import type { Map } from "mapbox-gl"

interface EnvironmentLayerOptions {
	baseUrl: string
	sourceName: string
	layerName: string
	visibleLayers: string[]
}

export function addFloodableZones(
	map: Map,
	{ baseUrl, visibleLayers, layerName, sourceName }: EnvironmentLayerOptions
) {
	map.addSource(sourceName, {
		tiles: [`${baseUrl}/landerz_models.floodable_area_polygons/{z}/{x}/{y}.pbf`],
		type: "vector",
	})
	map.addLayer({
		id: layerName,
		source: sourceName,
		"source-layer": "landerz_models.floodable_area_polygons",
		type: "fill",
		layout: {
			visibility: visibleLayers.includes("floodable-zones") ? "visible" : "none",
		},
		paint: {
			"fill-opacity": 0.2,
			"fill-color": "#00BFFF",
		},
		metadata: { custom: true },
	})
}

export function addWetlands(map: Map, { baseUrl, visibleLayers, layerName, sourceName }: EnvironmentLayerOptions) {
	map.addSource(sourceName, {
		type: "vector",
		tiles: [`${baseUrl}/landerz_models.milieux_humides_sudqc_2022/{z}/{x}/{y}.pbf`],
	})
	map.addLayer({
		id: layerName,
		source: sourceName,
		"source-layer": "landerz_models.milieux_humides_sudqc_2022",
		type: "fill",
		layout: {
			visibility: visibleLayers.includes("wetlands") ? "visible" : "none",
		},
		paint: {
			"fill-opacity": 0.2,
			"fill-color": "#3B9C9C",
		},
		minzoom: 13,
		metadata: { custom: true },
	})
}
